import { render, staticRenderFns } from "./RevisarContatosDialog.vue?vue&type=template&id=3139e7b0&scoped=true"
import script from "./RevisarContatosDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisarContatosDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RevisarContatosDialog.vue?vue&type=style&index=0&id=3139e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139e7b0",
  null
  
)

export default component.exports